import { render, staticRenderFns } from "./PorModelos.vue?vue&type=template&id=adada5fc&scoped=true&lang=pug&"
import script from "./PorModelos.vue?vue&type=script&lang=js&"
export * from "./PorModelos.vue?vue&type=script&lang=js&"
import style0 from "./PorModelos.vue?vue&type=style&index=0&id=adada5fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adada5fc",
  null
  
)

export default component.exports